import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";
import { getRedirectAfterWaitingRoom } from "./waitingRoomGuard";

/**
 * Cierra el onboarding a partir de la sala de espera (CSCOF): si la solicitud ya llegó ahí y el
 * usuario intenta volver a una pantalla anterior (botón "atrás" del navegador o url a mano), lo
 * regresa a la pantalla de su status actual. Las demás rutas pasan sin cambios.
 */
const ProtectRouteAfterWaitingRoom = () => {
  const { pathname } = useLocation();
  const statusConfig = useSelector((state: RootState) => state.app.status_config);
  const loanStatus = useSelector((state: RootState) => state.register.loan_status);

  const redirect = getRedirectAfterWaitingRoom(statusConfig, loanStatus, pathname);
  if (redirect) return <Navigate to={redirect} replace />;

  return <Outlet />;
};

export default ProtectRouteAfterWaitingRoom;
